export default __webpack_public_path__ + "static/artifakt-legend-regular-2e408115d22cb1e139d4c07893e43ca7.svg";